// extracted by mini-css-extract-plugin
export var productImage = "_vs-0";